import {
  IsEmail,
  IsNumber,
  IsOptional,
  IsString,
  Length,
  MaxLength,
  MinLength,
  ValidateIf,
} from 'class-validator';

export class CreateSweetFaceMerchantRequestDto {
  // @ApiProperty({ description: 'Pie Merchant ID', type: Number, example: 1 })
  @IsNumber()
  pieMerchantId: number;

  // @ApiProperty({ description: 'Contact email', example: 'manager@pieshop.com' })
  @IsOptional()
  @ValidateIf((o, _) => 'contactEmail' in o && o?.vatNumber?.length > 0)
  @IsEmail()
  contactEmail: string;

  // @ApiProperty({ description: 'Merchant name', example: 'Pieshop' })
  @IsString()
  @MinLength(1)
  @MaxLength(255)
  name: string;

  // @ApiProperty({
  //   description: 'Merchant currency as 3 letter ISO code',
  //   example: 'EUR',
  // })
  @Length(3, 3)
  currencyCode: string;

  // @ApiProperty({
  //   description: 'Merchant address',
  //   example: '1234 Main Street, Dublin, Ireland',
  // })
  @MaxLength(255)
  address: string;

  // @ApiProperty({ description: 'VAT number', example: 'IE123456789' })
  @IsOptional()
  @ValidateIf((o, _) => 'vatNumber' in o && o?.vatNumber?.length > 0)
  @IsString()
  @MaxLength(55)
  vatNumber: string;
}
